// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-iu__stars,.frisbuy-iu__stars-wrap{width:-moz-fit-content;width:fit-content}.frisbuy-iu__stars{line-height:unset!important}.vue3-star-ratings__inner{line-height:12px!important}.frisbuy-iu__stars .vue3-star-ratings__icon{padding:7px;box-sizing:content-box}.frisbuy-iu__stars svg{display:block;width:42px;height:42px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
